var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.route=='/employer/contract')?_c('EmpContract'):_vm._e(),(_vm.route=='/employer/contract/add-new')?_c('EmpAddContract'):_vm._e(),(_vm.route=='/employer/contract/request')?_c('EmpNewRequest'):_vm._e(),(_vm.route=='/employer/contract/details')?_c('EmpSingleContract'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }